/**
 * Opens and closes the navigation
 */

define('libs/navigation',[],function() {

    'use strict';

    var SETTINGS = {
        classActive: 'nav-active',
        classOpened: 'nav-opened',
        classOverflow: 'nav-noscroll',
        toggleSelector: '.nav-link',
        closeSelector: '.nav-close, .wrap',
        markOpenedAfter: 600 // nav is fully open after x milliseconds.
    };

    var Navigation = function(settings) {
        this.settings = $.extend({}, SETTINGS, settings || {});

        this.toggleButton = $(this.settings.toggleSelector);
        this.toggleButton.on('click', this.toggle.bind(this));
        this.closeButton = $(this.settings.closeSelector);
        this.closeButton.on('click', this.close.bind(this));
        this.active = false;
    };

    /**
     * Toggle the navigation (open/closed).
     * @param {Event} event The event that triggered the navigation toggle.
     */
    Navigation.prototype.toggle = function(event) {
        event.preventDefault();
        if (this.active) {
            this.close();
        } else {
            this.open();
        }
    };

    /**
     * Open the navigation.
     */
    Navigation.prototype.open = function() {
        this.active = true;
        $(document.documentElement).addClass(this.settings.classActive + ' ' + this.settings.classOverflow);
        // set class when navigation is fully opened.
        setTimeout(function() {
            $(document.documentElement).addClass(this.settings.classOpened);
        }.bind(this), this.settings.markOpenedAfter);

        // close menu on escape key.
        this.esc_closer = this.esc_closer || function(event) {
            if (event.which == 27) {
                this.close();
            }
        }.bind(this);

        $(window).on('keyup', this.esc_closer);
    };

    /**
     * Close the navigation.
     */
    Navigation.prototype.close = function(event) {
        if (event && $(event.target).is(this.settings.closeSelector)) {
            this.active = false;
            $(document.documentElement).removeClass(this.settings.classActive + ' ' + this.settings.classOpened);
            setTimeout(function() {
                $(document.documentElement).removeClass(this.settings.classOverflow);
            }.bind(this), this.settings.markOpenedAfter);

            $(window).off('keyup', this.esc_closer);
        }

    };

    return Navigation;
});

